import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";

import { BlobModelRepository } from "./repositories/blob-model.repository";
import { ToolModelRepository } from "./repositories/tool-model.repository";
import { AddonPaymentModelRepository } from "./repositories/addonpayment-model.repository";
import { ExcelGeneratorRepository } from "./repositories/excel-generator.repository";
import { BusinessCentralModelRepository } from "./repositories/business-central-model.repository";
import { CustomerModelRepository } from "./repositories/customer-model.repository";
import { SaleModelRepository } from "./repositories/sale-model.repository";
import { ClientModelRepository } from "./repositories/client-model.repository";
import { PackModelRepository } from "./repositories/pack-model.repository";
import { PurchasedPackModelRepository } from "./repositories/purchased-pack.repository";

import { TranslateServiceAux } from "./services/translate/translate.service";
import { BlobModelService } from "./services/blob-model/blob-model.service";

import { Service } from "./services/service.class";
import { UserModelService } from "./services/user/user-model.service";
import { LocalStorageService } from "./services/localStorage/local-storage.service";
import { AzureStorageService } from "./services/azureStorage/azure-storage.service";
import { AuthenticationService } from "./services/user/authentication.service";
import { ToolsService } from "./services/tools/tools.service";
import { DataService } from "./services/data/data.service";
import { AddonPaymentModelService } from "./services/addonPayment/addonPayment-model.service";
import { ExcelGeneratorService } from "./services/excelGenerator/excel-generator.service";
import { BusinessCentralService } from "./services/businessCentral/businessCentral.service";
import { SalesService } from "./services/sales/sales.service";
import { ClientModelService } from "./services/client-model/client-model.service";
import { FileSaverService } from "./services/fileSaver/fileSaver.service";
import { PurchasesService } from "./services/purchases/purchases.service";
import { ModalitiesService } from "./services/data/modalities.service";

@NgModule({
	imports: [CommonModule],
	providers: [
		provideHttpClient(withInterceptorsFromDi()),
		TranslateServiceAux,
		ExcelGeneratorService,
		BusinessCentralService,
		ToolsService,
		SalesService,
		BlobModelService,
		AzureStorageService,
		DataService,
		LocalStorageService,
		Service,
		UserModelService,
		LocalStorageService,
		AuthenticationService,
		AddonPaymentModelService,
		ClientModelService,
		FileSaverService,
		ModalitiesService,
		BlobModelRepository,
		ExcelGeneratorRepository,
		BusinessCentralModelRepository,
		ToolModelRepository,
		CustomerModelRepository,
		AddonPaymentModelRepository,
		SaleModelRepository,
		ClientModelRepository,
		PackModelRepository,
		PurchasedPackModelRepository,
		PurchasesService,
	],
})
export class CoreModule {
}
